
































import { defineComponent } from "@vue/composition-api";
import NumberFormatter from "@/services/number.formatter";
import { BlockLabel } from "@/models/BlockLabel";
import { Expandable, TextField } from "@/components";

export default defineComponent({
  name: "PricePerUnitManYears",
  components: {
    Expandable,
    TextField,
  },
  props: {
    initialLimit: { type: Number, default: 0 },
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
    initialUnitPrice: { type: Number, default: null },
  },
  data() {
    return {
      displayName: BlockLabel.PricePerUnitManYears,
      unitPrice: this.initialUnitPrice || 0,
    };
  },
  computed: {},
  mounted() {
    if (this.data) {
      this.unitPrice = this.data.unitPrice;
    }
  },
  methods: {
    isUnitPriceValid(): boolean {
      return this.unitPrice !== null && this.unitPrice > 0;
    },
    getUnitPriceLabel(): string {
      return this.isUnitPriceValid() ? `kr ${this.unitPrice} per` : "ugyldig";
    },
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock(): void {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        unitPrice: this.isUnitPriceValid() ? this.unitPrice : 0,
      });
    },
    getNewColor(index: number): string {
      var colors = ["#39CCCC", "#FF9186", "#B4DA55", "#B5649b"];

      index = index % colors.length;

      return colors[index];
    },
    shortenedNumber(number: number): string {
      return NumberFormatter.shortForm(number, 3);
    },
    asCurrency(number: number): string {
      return `${NumberFormatter.withThousandsSeparator(number, " ")}`;
    },
  },
});
